/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { BadgeResponse, GoalResponse, Playlist } from '../../../../shared/models';
import { LoadableState, defaultLoadableState } from '../../../../shared/store';

/** The Playlist view main state model. */
export interface PlaylistViewStateModel {
  /** The content for the Playlist view. */
  resource: LoadableState<Playlist>;
  /** Defines if card was opened */
  cardWasOpened: boolean;
  goal: GoalResponse | null;
  goalBadge: BadgeResponse | null;
  /** True once LoadPlaylistGoal has fully settled (success or no badge) */
  goalLoaded: boolean;
}

/** Initial empty state of the lerner view. */
export const INITIAL_STATE: PlaylistViewStateModel = {
  resource: defaultLoadableState(),
  cardWasOpened: false,
  goal: null,
  goalBadge: null,
  goalLoaded: false,
};
